
import { AuthPayload } from '@/interfaces/ui.interface'
import api from '@/plugins/axios'

export default {
  async login({ commit }: any, formData: FormData) {
    const payload: AuthPayload = {
      data: null,
      success: false,
      message: '',
      show: true
    }
    try {
      const response = await api.post('/auth', formData)
      if (response.data && response.data.token) {
        payload.data = response.data
        payload.success = true
        payload.message = 'Autenticación exitosa'
      } else {
        payload.message = 'Respuesta inesperada del servidor'
      }
    } catch (error: any) {
      payload.data = error
      payload.message = (!error.response)
        ? 'No se pudo conectar al servidor...'
        : `Error al autenticar: ${error.response.data?.message || 'Error desconocido'}`
    } finally {
      commit('Ui/setSnackbar', {
        text: payload.message,
        color: (payload.success) ? 'success' : 'error',
        show: payload.show
      }, { root: true })
      commit('setAuth', payload)
    }
  }
}
